import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OrderRequest } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ContractConfirmation } from '../entities/contract-confirmation.entity';

@Injectable({
  providedIn: 'root',
})
export class ContractConfirmationInfrastructure {
  private readonly _http = inject(HttpClient);
  private readonly _api = `${environment.apihost}/api`;

  public loadRequiredContractConfirmations(): Observable<ContractConfirmation[]> {
    return this._http.get<ContractConfirmation[]>(`${this._api}/clientconfig/contract/confirmation-required`);
  }

  public acceptContracts(contracts: ContractConfirmation[]) {
    return this._http.put<ContractConfirmation[]>(`${this._api}/clientconfig/contract/confirmation-required`, contracts);
  }

  public verifyOrder(orderData: OrderRequest) {
    return this._http.post(`${this._api}/trading/order/verify`, orderData);
  }
}
